class Animation {
    constructor() {
        this.isScrolling = false;
        this.onVisibleTargets = [];
        this.bodyElement = document.querySelector('body');


        this.registerOnVisibleElements();
        this.bindEvents();

        requestAnimationFrame(() => {
            this.triggerOnload();
            this.calculateVisibleElements();
        });
    }

    init() {
    }

    registerOnVisibleElements() {
        this.onVisibleTargets = Array.from(document.querySelectorAll('[class*="onvisible-"]'));
    }

    calculateElementPositions() {
        for (let i = 0; i < this.onVisibleTargets.length; i++) {
            this.onVisibleTargets[i].clientRect = this.onVisibleTargets[i].getBoundingClientRect();
        }
    }

    calculateVisibleElements() {
        this.calculateElementPositions();

        let removeableElements = [];
        const windowHeight = window.innerHeight || Math.max(document.documentElement.clientHeight, document.body.clientHeight);

        for (let i = 0; i < this.onVisibleTargets.length; i++) {
            /**
             * Check if the element is full in the viewport by the class 'is-waiting-full-visibility'
             */
            if (this.onVisibleTargets[i].classList.contains('is-waiting-full-visibility')) {
                const rect = this.onVisibleTargets[i].clientRect;
                const isCompletelyInViewport =
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth);

                if (isCompletelyInViewport && !this.onVisibleTargets[i].classList.contains('is-visible')) {
                    this.onVisibleTargets[i].classList.add('is-visible');
                    removeableElements.push(i);
                }
            /**
             * otherwise will run the logic before
             */
            } else {
                if (this.onVisibleTargets[i].clientRect.top - (this.onVisibleTargets[i].clientRect.height * 0.75) <= windowHeight) {
                    this.onVisibleTargets[i].classList.add('is-visible');

                    removeableElements.push(i);
                }
            }
        }

        if (removeableElements.length) {
            removeableElements.reverse();

            removeableElements.forEach(index => {
                this.onVisibleTargets.splice(index, 1);
            });
        }

        this.isScrolling = false;
    }

    bindEvents() {
        this.scrollHandler = this.handleScroll.bind(this);
        document.addEventListener('scroll', this.scrollHandler);
    }

    triggerOnload() {
        this.bodyElement.classList.add('animation-ready');
    }

    handleScroll() {
        if (!this.onVisibleTargets.length) {
            document.removeEventListener('scroll', this.scrollHandler);
            return;
        }

        if (this.isScrolling) {
            return;
        }

        this.isScrolling = true;

        requestAnimationFrame(this.calculateVisibleElements.bind(this));
    }
}

export default new Animation();
